import { render, staticRenderFns } from "./BasicTabs.vue?vue&type=template&id=a4c46fca&scoped=true&"
import script from "./BasicTabs.vue?vue&type=script&lang=js&"
export * from "./BasicTabs.vue?vue&type=script&lang=js&"
import style0 from "./BasicTabs.vue?vue&type=style&index=0&id=a4c46fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c46fca",
  null
  
)

export default component.exports